export default "/images/vendor/flag-icon-css/flags/4x3/sz.svg?d62f5eab640be40355e8fdca853ed0a4";